import { compose, setDisplayName } from 'react-recompose';

import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading.js';

import { fetchSuperPortal } from '~/state/ducks/organizations/operations.js';
import { getOrgData } from '~/state/ducks/organizations/selectors.js';

import SystemPortalView from '../components/SystemPortalView.jsx';


export default compose(
    setDisplayName('OrganizationsViewContainer'),
    withReduxDataLoading({
        name: 'fetchSuperPortal',
        operation: ({ match: { params: { id } } }) => fetchSuperPortal(id),
        selector: getOrgData,
    }),
    withLoadingBranch,
)(SystemPortalView);
